import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import announcer from './aria-announcer';

gsap.registerPlugin(ScrollTrigger);

const heroBanner = document.querySelector('.hero-banner');
const topTriangle = document.querySelector('.hero-banner-top-triangle');
const bottomTriangle = document.querySelector('.hero-banner-bottom-triangle');
const desktopVideo = document.querySelector('.hero-banner-video');

if (heroBanner) {
    gsap.to(topTriangle, {
        x: '-100%',
        ease: 'power2.out',
        scrollTrigger: {
            trigger: '.header',
            start: 'top top',
            end: '+=500',
            scrub: true,
        },
    });

    gsap.to(bottomTriangle, {
        x: '100%',
        ease: 'power2.out',
        scrollTrigger: {
            trigger: '.header',
            start: 'top top',
            end: '+=500',
            scrub: true,
        },
    });
    // Video controls
    const actionButton = document.querySelector('.video-actions');
    const actionButtonDescription = document.querySelector('.video-actions-description');

    // Play/Pause
    actionButton?.addEventListener('click', () => {
        const video = desktopVideo;
        if (video.paused) {
            video.play();
            announcer.announce('La vidéo est lancée');
            actionButton.querySelector('.icon-play').style.display = 'none';
            actionButton.querySelector('.icon-pause').style.display = 'inline-block';
            actionButtonDescription.innerHTML = 'Mettre la vidéo sur pause';
        } else {
            video.pause();
            announcer.announce('La vidéo a été arrêtée');
            actionButton.querySelector('.icon-pause').style.display = 'none';
            actionButton.querySelector('.icon-play').style.display = 'inline-block';
            actionButtonDescription.innerHTML = 'Lecture de la vidéo';
        }
    });
}
